import { Baby, Cake, Heart, MessageSquareHeart } from 'lucide-react'

type Template = {
  id: string
  label: string
  icon: React.ReactNode
  description: string
  placeholder: string
}

const templates: Template[] = [
  {
    id: 'birthday',
    label: 'Verjaardag',
    icon: <Cake className="w-5 h-5" />,
    description: 'Maak een feestelijke verjaardagskaart',
    placeholder: 'bijv. "Gefeliciteerd Lisa!"',
  },
  {
    id: 'wedding',
    label: 'Huwelijk',
    icon: <Heart className="w-5 h-5" />,
    description: 'Maak een elegante huwelijksdesign',
    placeholder: 'bijv. "Jan & Marie"',
  },
  {
    id: 'baby',
    label: 'Geboorte',
    icon: <Baby className="w-5 h-5" />,
    description: 'Maak een schattige geboortekaart',
    placeholder: 'bijv. "Emma, 15 juni 2025"',
  },
  {
    id: 'thank_you',
    label: 'Bedankt',
    icon: <MessageSquareHeart className="w-5 h-5" />,
    description: 'Maak een bedankkaartje',
    placeholder: 'bijv. "Dank je wel!"',
  },
]

type TemplateSelectorProps = {
  selectedTemplate: string | null
  onSelectTemplate: (templateId: string | null) => void
}

export const TemplateSelector = ({ selectedTemplate, onSelectTemplate }: TemplateSelectorProps) => {
  return (
    <div className="grid grid-cols-2 gap-2">
      {templates.map((template) => (
        <button
          key={template.id}
          onClick={() => onSelectTemplate(selectedTemplate === template.id ? null : template.id)}
          className={`flex flex-col items-center gap-1 p-3 rounded-xl border-2 transition-all ${
            selectedTemplate === template.id
              ? 'border-purple-500 bg-purple-50 text-purple-700'
              : 'border-gray-200 bg-white text-gray-600 hover:border-purple-200 hover:bg-purple-50/50'
          }`}
        >
          <div
            className={`p-2 rounded-full ${
              selectedTemplate === template.id ? 'bg-purple-100' : 'bg-gray-100'
            }`}
          >
            {template.icon}
          </div>
          <span className="text-sm font-medium">{template.label}</span>
        </button>
      ))}
    </div>
  )
}

export const getTemplatePlaceholder = (templateId: string): string => {
  const template = templates.find((t) => t.id === templateId)
  return template?.placeholder || 'Beschrijf wat je wilt maken...'
}

export const getTemplateDescription = (templateId: string): string => {
  const template = templates.find((t) => t.id === templateId)
  return template?.description || ''
}
